<template>
  <div class="p-4">
    <button @click="newSupplier" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 rounded">
      New Supplier
    </button>
    <el-table
      :data="suppliers.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name"
        sortable>
      </el-table-column>
      <el-table-column
        label="Address"
        sortable>
        <template slot-scope="scope">{{scope.row.address}} {{scope.row.city}}, {{scope.row.state.name}}, {{scope.row.country.name}}</template>
      </el-table-column>
      <el-table-column
        prop="contact_person"
        label="Contact Person"
        sortable>
      </el-table-column>
      <el-table-column
        prop="status"
        label="Enabled">
        <template slot-scope="scope">
          <span v-if="scope.row.status === true"><el-tag size="small" type="success">Yes</el-tag></span>
          <span v-else><el-tag size="small" type="danger">No</el-tag></span>
        </template>
      </el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="search"
            size="mini"
            placeholder="Type to search"/>
        </template>
        <template slot-scope="scope">
          <el-button @click="viewSupplier(scope.row.id)" type="text" size="small">
            <i class="text-xl text-gray-500 el-icon-view mr-1"></i>
          </el-button>
          <el-button @click="editSupplier(scope.row.id)" type="text" size="small">
            <i class="text-xl el-icon-edit-outline mr-4"></i>
          </el-button>
          <el-button @click="deleteSupplier(scope.row.id)" type="text" size="small">
            <i class="text-xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

import { flatMap } from 'lodash';

export default {
  name: 'Suppliers',
  data() {
    return {
      search: '',
    };
  },
  computed: {
    suppliers() {
      return flatMap(this.$store.state.InventoryModule.Suppliers.suppliers);
    },
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
  methods: {
    newSupplier() {
      this.$router.push('/ecommerce/supply/suppliers/new');
    },
    viewSupplier(id) {
      this.$router.push(`/ecommerce/supply/suppliers/${id}/details`);
    },
    editSupplier(id) {
      this.$router.push(`/ecommerce/supply/suppliers/${id}/edit`);
    },
    deleteSupplier(supplierId) {
      this.$confirm('Are you sure you want to delete this supplier?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/Suppliers/deleteSupplier', { supplierId });
          this.$notify.success({
            title: 'Success',
            message: 'Supplier has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
